import React from 'react'
import { View } from '@infominds/react-native-components';

export default function QrScannerPopUp() {
    return (
        <View></View>
    )
}